import React, { useState } from 'react'
import { Backdrop, Fade,Input,InputLabel,makeStyles, MenuItem, Modal, Select, useTheme } from '@material-ui/core'
import PropTypes from 'prop-types';

import { StepChart } from '../../charts/StepChart';



const useStyles = makeStyles((theme) => ({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
};

/**
 * Lets get the style and modify it for size 
 * @param {string} point 
 * @param {string} pointsName 
 * @param {string} theme 
 */
const getStyles =(point, pointsName, theme)=>{
    return {
      fontWeight:
        pointsName.indexOf(point) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
}


export const GisInformationPointsModal = ({
                                            openModal=false, 
                                            closeModal, 
                                            data=[{
                                                    nombre: '',
                                                    fecha_on: '',
                                                    nivel: 0,
                                                }]
                                        }) => {

    const classes = useStyles();
    const theme = useTheme();


    const [pointsName, setPointsName] = useState("")

    const dataNames = data.map(name=>name.nombre)
    /**
     * Remove repeating elements to put only names 
     * @param {string} value the same element to be removed 
     * @param {number} index number of the element
     * @param {string} self element to be removed 
     * @returns Array without repeating elements 
     */
    const removeRepeatedElement =(value, index, self)=> { 
        return self.indexOf(value) === index;
    }              
    const pointsElements = dataNames.filter( removeRepeatedElement );
    const filterDataByName= data.filter(data=>data.nombre === pointsName);

    const handleChangeInput = (event) => {
        setPointsName(event.target.value);
    };

    
    return (
        <Modal
            aria-labelledby="tablas"
            aria-describedby="descripcion-tablas"
            className={classes.modal}
            open={openModal }
            onClose={closeModal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={openModal}>
                <div className={classes.paper}>
                    <InputLabel id="name-points">Ultimas Alertas Activas</InputLabel>
                    <Select
                        labelId="names-points"
                        id="multiplePoints"
                        value={pointsName}
                        onChange={handleChangeInput}
                        input={<Input />}
                        MenuProps={MenuProps}
                        
                    >
                        <MenuItem value="" disabled>
                            <em>Sin Alertas Recientes</em>
                        </MenuItem>
                        {pointsElements.map((nameAlarm)=>(
                            <MenuItem key={nameAlarm} value={nameAlarm} style={getStyles(nameAlarm, pointsName, theme)}>
                                {nameAlarm}
                            </MenuItem>
                        ))}
                    </Select>

                    <div className={classes.paper}>
                        <StepChart 
                            realtime
                            dataChartStep={filterDataByName}
                            namePoint = {pointsName} 
                        />
                    </div>         
                    
                </div>
            </Fade>
        </Modal>
    )
}

GisInformationPointsModal.prototype = {
    closeModal: PropTypes.func.isRequired,
    openModal: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
}
